import React from 'react';
import './Footer.css';

const Footer = ({ isDarkMode }) => {
    return (
        <footer className={`global-footer ${isDarkMode ? 'dark' : 'light'}`}>
            <div className="footer-content">
                <span>© 2026 m🙂jie</span>
                <span className="footer-divider">|</span>
                <span>Part of the Mojie Games bundle</span>
                <span className="footer-divider">|</span>
                <a href="/privacy-policy.html" className="footer-link">Privacy Policy</a>
            </div>
        </footer>
    );
};

export default Footer;
